export const getConditionCaseNumber = (conditions) => {
  const { min_length, deadline_days, picture_upload } = conditions;

  const conditionsInBoolean = [
    deadline_days > 0,
    min_length > 0,
    picture_upload > 0,
  ];

  const caseNumber = conditionsInBoolean.reduce((acc, curr, idx) => {
    return acc + (curr ? Math.pow(2, idx) : 0);
  }, 1);

  return caseNumber;
};
